/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_ChooseInputs */

const en_us2_swap_choose = /** @type {(inputs: Swap_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose`)
};

const pt_br2_swap_choose = /** @type {(inputs: Swap_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher`)
};

const es_419_swap_choose = /** @type {(inputs: Swap_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir`)
};

const pt_pt2_swap_choose = /** @type {(inputs: Swap_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher`)
};

const fr_fr2_swap_choose = /** @type {(inputs: Swap_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir`)
};

const de_de2_swap_choose = /** @type {(inputs: Swap_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen`)
};

const it_it2_swap_choose = /** @type {(inputs: Swap_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli`)
};

/**
* | output |
* | --- |
* | "Choose" |
*
* @param {Swap_ChooseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_choose = /** @type {((inputs?: Swap_ChooseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_ChooseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_choose(inputs)
	if (locale === "es-419") return es_419_swap_choose(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_choose(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_choose(inputs)
	if (locale === "de-DE") return de_de2_swap_choose(inputs)
	if (locale === "it-IT") return it_it2_swap_choose(inputs)
	return en_us2_swap_choose(inputs)
});
export { swap_choose as "swap.choose" }